import { Component, inject, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CmmsDatePickerComponent } from '@app/pages/cmms/components/shared-form-group-controls/cmms-date-picker/cmms-date-picker.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

export type NewTimeseriesValue = {
	component?: string;
	value?: number;
	unit?: string;
	date?: Date;
};

@Component({
	selector: 'new-timeseries-value',
	templateUrl: './new-timeseries-value.component.html',
	styleUrl: './new-timeseries-value.component.scss',
	imports: [
		MatFormFieldModule,
		MatInputModule,
		FormsModule,
		MatButtonModule,
		MatDialogTitle,
		MatDialogContent,
		MatDialogActions,
		MatDatepickerModule,
		CmmsDatePickerComponent,
		NgxTolgeeModule,
	],
})
export class NewTimeseriesValueComponent {
	readonly dialogRef = inject(MatDialogRef<NewTimeseriesValueComponent>);
	readonly data = inject<NewTimeseriesValue>(MAT_DIALOG_DATA);

	readonly value = model(this.data.value);
	readonly date = model(this.data.date);
	readonly hour = model(this.data.date?.getHours());
	readonly minute = model(this.data.date?.getMinutes());

	cancel(): void {
		this.dialogRef.close();
	}

	submit() {
		const newDate = new Date(this.date());
		newDate.setHours(this.hour(), this.minute());
		this.dialogRef.close({
			date: newDate,
			value: this.value(),
			unit: this.data.unit,
		});
	}
}
